/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import withToggle from '../../../common/hoc/withToggle';
import TaxBreakdownModal from './TaxBreakdownModal';
import { MoneyFitSmall } from './MoneyFit';
import { taxBreakdownArray } from '../shapes';

const TaxBreakdown = (props) => {
  const { breakdown, shouldShowModalOn, shouldShowModalOff, shouldShowModalIsOn, amount } = props;

  return (
    <div className="u-type--underline u-cursor-pointer" onClick={shouldShowModalOn}>
      <MoneyFitSmall automationId="text:taxBreakdownAmount">{amount}</MoneyFitSmall>
      <TaxBreakdownModal breakdown={breakdown} close={shouldShowModalOff} display-if={shouldShowModalIsOn} />
    </div>
  );
};

TaxBreakdown.propTypes = {
  breakdown: taxBreakdownArray,
  amount: PropTypes.number,
  shouldShowModalOn: PropTypes.func.isRequired,
  shouldShowModalOff: PropTypes.func.isRequired,
  shouldShowModalIsOn: PropTypes.bool.isRequired,
};

TaxBreakdown.defaultProps = {
  breakdown: [],
  amount: 0,
};

export default withToggle('shouldShowModal', false)(TaxBreakdown);
